import { useState } from 'react'
import { Avatar, AppBar, Box, Divider, Drawer, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Skeleton, Stack, Toolbar, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import AlternateEmailRounded from '@mui/icons-material/AlternateEmailRounded'
import InboxRounded from '@mui/icons-material/InboxRounded'
import SendRounded from '@mui/icons-material/SendRounded'
import ContactsRounded from '@mui/icons-material/ContactsRounded'
import CampaignRounded from '@mui/icons-material/CampaignRounded'
import SettingsRounded from '@mui/icons-material/SettingsRounded'
import MenuRounded from '@mui/icons-material/MenuRounded'
import DarkModeRounded from '@mui/icons-material/DarkModeRounded'
import LightModeRounded from '@mui/icons-material/LightModeRounded'
import LogoutRounded from '@mui/icons-material/LogoutRounded'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import { TenantProvider, useTenant } from '../tenant/TenantProvider'
import { useColorMode } from '../theme/AppTheme'

const drawerWidth = 264
const nav = [
  { label: 'Caixa de entrada', path: '/inbox', icon: <InboxRounded /> },
  { label: 'Mensagens', path: '/messages', icon: <SendRounded /> },
  { label: 'Contatos', path: '/contacts', icon: <ContactsRounded /> },
  { label: 'Campanhas', path: '/campaigns', icon: <CampaignRounded /> },
]

function ShellContent() {
  const theme = useTheme(); const desktop = useMediaQuery(theme.breakpoints.up('md'))
  const [mobileOpen, setMobileOpen] = useState(false); const [anchor, setAnchor] = useState<null | HTMLElement>(null)
  const location = useLocation(); const navigate = useNavigate(); const auth = useAuth(); const tenant = useTenant(); const colorMode = useColorMode()
  const userName = auth.profile.name || auth.profile.email || 'Usuário'

  const drawer = <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}>
    <Stack direction="row" alignItems="center" spacing={1.3} px={1} py={1.3} mb={2}>
      {tenant.loading ? (
        <Skeleton variant="rounded" width={38} height={38} sx={{ borderRadius: 2.5 }} />
      ) : tenant.tenant?.logoDataUri ? (
        <Avatar src={tenant.tenant.logoDataUri} variant="rounded" sx={{ width: 38, height: 38 }} />
      ) : (
        <Box sx={{ width: 38, height: 38, borderRadius: 2.5, display: 'grid', placeItems: 'center', color: 'white', background: 'linear-gradient(135deg,#4f46e5,#06b6d4)' }}><AlternateEmailRounded /></Box>
      )}
      <Box minWidth={0}>
        <Typography fontWeight={800} lineHeight={1.1} noWrap>{tenant.tenant?.name ?? 'E-mail'}</Typography>
        <Typography variant="caption" color="text.secondary">Caixa de e-mail</Typography>
      </Box>
    </Stack>
    <List sx={{ display: 'grid', gap: 0.5 }}>{nav.map((item) => <ListItemButton key={item.path} selected={location.pathname === item.path} onClick={() => { navigate(item.path); setMobileOpen(false) }} sx={{ borderRadius: 2.5, py: 1.1 }}><ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon><ListItemText primary={item.label} primaryTypographyProps={{ fontWeight: 600 }} /></ListItemButton>)}</List>
    <Box flex={1} />
    <Divider sx={{ mb: 1 }} />
    <ListItemButton selected={location.pathname === '/settings'} onClick={() => navigate('/settings')} sx={{ borderRadius: 2.5 }}><ListItemIcon sx={{ minWidth: 40 }}><SettingsRounded /></ListItemIcon><ListItemText primary="Configurações" /></ListItemButton>
  </Box>

  return <Box sx={{ display: 'flex', minHeight: '100vh' }}>
    {desktop ? <Drawer variant="permanent" sx={{ width: drawerWidth, '& .MuiDrawer-paper': { width: drawerWidth, borderRightColor: 'divider', bgcolor: 'background.paper' } }}>{drawer}</Drawer> : <Drawer open={mobileOpen} onClose={() => setMobileOpen(false)} sx={{ '& .MuiDrawer-paper': { width: drawerWidth } }}>{drawer}</Drawer>}
    <Box component="main" sx={{ flex: 1, minWidth: 0 }}>
      <AppBar position="sticky" color="transparent" elevation={0} sx={{ backdropFilter: 'blur(16px)', borderBottom: 1, borderColor: 'divider', bgcolor: 'rgba(255,255,255,.72)', ...theme.applyStyles('dark', { bgcolor: 'rgba(7,11,20,.72)' }) }}><Toolbar sx={{ gap: 1.5 }}>
        {!desktop && <IconButton onClick={() => setMobileOpen(true)}><MenuRounded /></IconButton>}
        <Box flex={1} />
        <Tooltip title={colorMode.dark ? 'Tema claro' : 'Tema escuro'}><IconButton onClick={colorMode.toggle}>{colorMode.dark ? <LightModeRounded /> : <DarkModeRounded />}</IconButton></Tooltip>
        <IconButton onClick={(event) => setAnchor(event.currentTarget)}><Avatar sx={{ width: 34, height: 34, bgcolor: 'primary.main', fontSize: 14, fontWeight: 700 }}>{userName.slice(0, 2).toUpperCase()}</Avatar></IconButton>
        <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}><Box px={2} py={1}><Typography fontWeight={700}>{userName}</Typography><Typography variant="caption" color="text.secondary">{auth.profile.email}</Typography></Box><Divider /><MenuItem onClick={() => auth.logout()}><LogoutRounded fontSize="small" sx={{ mr: 1.5 }} />Sair</MenuItem></Menu>
      </Toolbar></AppBar>
      <Box sx={{ p: { xs: 2, sm: 3, lg: 4 }, maxWidth: 1500, mx: 'auto' }}><Outlet /></Box>
    </Box>
  </Box>
}

export function AppShell() { return <TenantProvider><ShellContent /></TenantProvider> }
